export const dataset = {
  delete: {
    label: "Supprimer le dataset",
  },
  update: {
    label: "Modifier le dataset",
  },
  form: {
    name: {
      label: "Nom",
    },
    description: {
      label: "Description",
    },
  },
  saveToDelete: "Sauvegarder pour supprimer de manière permanente",
  zoom: {
    openModal: "Plein écran",
  },
  cartesian: {
    imageTitle: "Image du cartésien",
    clickableAreaLabel: "Cliquer pour définir la position du cartésien",
  },
};
